import { useRouter } from "next/router";
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import Head from "next/head";
const Navbar = dynamic(() =>
  import("../../components/Layouts/Navbar", { ssr: false })
);
const Footer = dynamic(() =>
  import("../../components/Layouts/Footer", { ssr: false })
);
const Breadcrumb = dynamic(() =>
  import("../../components/Layouts/Breadcrumb", { ssr: false })
);
const ContentSection = dynamic(() =>
  import("../../components/Newsletter-Whitepaper/ContentSection", {
    ssr: false,
  })
);
const RelatedPost = dynamic(() =>
  import("../../components/Newsletter-Whitepaper/RelatedPost", { ssr: false })
);
const HeroBanner = dynamic(() =>
  import("../../components/Common/HeroBanner", { ssr: false })
);
import SideBarForm from "../../components/Common/SideBarForm";
import axios from 'axios'
import { HTMLParser } from "../../components/Common/Functions";


const NewsLetterWhitePaper = ({ data, isMobile }) => {
  const router = useRouter();
  const { slug } = router.query;

  const [newsdata, setNewsData] = useState([])
  const [newsletterData, setNewsletterData] = useState("");

  useEffect(() => {
    console.log(data)
    if (data != null) {
      setNewsletterData(data)
      setTrigger(true)
    } else {
      router.push('/404')
    }
  }, [data])

  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    // console.log(newsletterData)
    if (newsletterData?.description) {
      HTMLParser(newsletterData?.description, setNewsData)
    }
  }, [trigger]);

  const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)
    useEffect(() => {
        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    useEffect(() => {
        if (scrolled > 20) {
            setScrolledStatus(true)
        }
    }, [scrolled])

  return (
    <>

      <Navbar />
      <div className="relative">
        <HeroBanner
          background={
            process.env.IMG_CDN +
            "img/whitepaper-newsletter/jpg/newsletter-banner.jpg"
          }
          title={(newsletterData?.slug)?.replace(/-/g, ' ')}
          customClass="text-white lg:text-black"
          description={
            <div className="lg:w-6/12 text-white lg:text-black">
              {newsletterData?.tag_line_on_Banner}
            </div>
          }
        />
        <div className="absolute right-0 top-10 hidden lg:block">
          {(newsletterData?.computer_image) &&
            <Image
              priority={false}
              className="w-full"
              src={process.env.IMG_CDN + newsletterData?.computer_image}
              alt={newsletterData?.computer_image_alt}
              width={2000}
              height={2000}
            />
          }
        </div>
      </div>
      <Breadcrumb />
      <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:my-8 my-4">
        <div className="grid grid-cols-12 gap-4">
          <div className="xl:col-span-9 lg:col-span-8 col-span-12">
            <ContentSection data={newsletterData} />
          </div>
          {(isMobile) ?
            (scrolledStatus) &&
            <div className="xl:col-span-3 lg:col-span-4 col-span-12">
              <div className="sticky top-20">
                <SideBarForm
                  page_name="Newsletter/Whitepaper Page"
                  form_name="newsletter-page-form"
                  title="Fill the details to get the complete Newsletter"
                  endpoint="/enquiry/newsletter-request"
                />
              </div>
            </div>:
            <div className="xl:col-span-3 lg:col-span-4 col-span-12">
              <div className="sticky top-20">
                <SideBarForm
                  page_name="Newsletter/Whitepaper Page"
                  form_name="newsletter-page-form"
                  title="Fill the details to get the complete Newsletter"
                  endpoint="/enquiry/newsletter-request"
                />
              </div>
            </div>
          }
        </div>
        { (scrolledStatus) &&
        <RelatedPost />
        }
      </div>
      { (scrolledStatus) &&
      <Footer />
      }
    </>
  );
};


export async function getServerSideProps({ req, res, resolvedUrl }) {
  const UA = req.headers['user-agent'];
  const isMobile = Boolean(UA.match(
    /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
  ))
  let redirecting = {
    redirect: {
      permanent: false,
      destination: "/404"
    }
  }

  let slug = resolvedUrl;
  try {
    let cleanedSlug = slug.replace(/\/$/, '');
    // console.log(cleanedSlug);
    cleanedSlug = cleanedSlug.replace(/\/whitepaper-newsletter\//, '');
    let apiUrl = process.env.API_URL + '/newsletter-whitepaper/' + cleanedSlug;
    // console.log(apiUrl);
    const output = await fetch(apiUrl, { method: 'GET', headers: { 'Content-Type': 'application/json', } });
    const response = await output.json();
    // console.log(response);
    if (response) {
      return {
        props: {
          title: (response?.meta.meta_title) ? response?.meta.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          description: (response?.meta.meta_description) ? response?.meta.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          keywords: (response?.meta.meta_keywords) ? response?.meta.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
          data: response ? response : [],
          isMobile: isMobile
        }
      }
    } else {
      return redirecting;
    }
  } catch (error) {
    console.log(error)
    return redirecting;
  }
}

export default NewsLetterWhitePaper;
